import React from 'react'
import OurTeamCard from '../assets/cards/OurTeamCard'
import { Box } from '@mui/system'
import { Grid, Typography } from '@mui/material'
import { mainHeading, subHeading } from '../styles/style'
import { ArrowForwardIos } from '@mui/icons-material'

export default function OurTeam() {
  return (
    <>
         <Box className="team-container" >
        <Grid container >
          <Grid item md={12} spacing={2} >
           <Box sx={{textAlign:'center', my:5}}>
            <Typography sx={subHeading}>Our Team</Typography>
            <Typography sx={mainHeading}>Meet Our Team</Typography>

            </Box>
             
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={3}>
                    <OurTeamCard/>
                    </Grid>
                    <Grid item xs={12} md={3}>
                    <OurTeamCard/>
                    </Grid>
                    <Grid item xs={12} md={3}>
                    <OurTeamCard/>
                    </Grid>
                    <Grid item xs={12} md={3}>
                    <OurTeamCard/>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} >
                    <Grid item xs={12} md={3}>
                    <OurTeamCard/>
                    </Grid>
                    <Grid item xs={12} md={3}>
                    <OurTeamCard/>
                    </Grid>
                    <Grid item xs={12} md={3}>
                    <OurTeamCard/>
                    </Grid>
                    <Grid item xs={12} md={3}>
                    <OurTeamCard/>
                    </Grid>
                  </Grid>
             
             
           
          

            <Box className="flexbgbtn">
              <button className="bgbtn" type="button">
                View More <ArrowForwardIos sx={{ fontSize: "16px" }} />{" "}
              </button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}
